import { createActions } from 'redux-actions'

export const {
  loader: { showLoader, hideLoader },
} = createActions({
  '@loader/showLoader': undefined,
  '@loader/hideLoader': undefined,
})
